module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/288_title_freespins@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-paytable/288_title_freespins@1x.png
// module id = 695
// module chunks = 0